import React, { FC } from "react";
import { requestStatus } from "../../constants/statusConstants";

const ApprovalStatus: FC<any> = ({ status, isDemand, id }) => {
  if (status === requestStatus.submitted) {
    return <span className="flag status warning">{"Đang đợi duyệt"}</span>;
  } else if (status === requestStatus.preApproved) {
    return <span className="flag status warning">{"Đang đợi duyệt"}</span>;
  } else if (status === requestStatus.approved) {
    return <span className="flag status success">{"Đã duyệt"}</span>;
  } else if ([requestStatus.inProgress, "InProgress"].includes(status)) {
    return <span className="flag status info">{isDemand ? "Đang tiếp nhận" : "Đang thực hiện"}</span>;
  } else if (status === requestStatus.acceptance) {
    return <span className="flag status success">{isDemand ? "Đã tiếp nhận" : "Tiến hành nghiệm thu"}</span>;
  } else if (status === requestStatus.completed) {
    return <span className="flag status success">{isDemand ? "Tiến hành thực hiện" : "Đã hoàn tất"}</span>;
  } else if (status === requestStatus.rejected) {
    return <span className="flag status danger">{"Đã bị từ chối"}</span>;
  }  else if (status === requestStatus.canceled) {
    return <span className="flag status danger">{"Đã Huỷ"}</span>;
  }

  return <></>;
};

export default ApprovalStatus;
